import noBookCover from '../assets/no-book-cover.png';
import { resolveApiAsset } from './image';

const PLACEHOLDER = noBookCover;

export const getBookImage = (src) => {
  return resolveApiAsset(src) || PLACEHOLDER;
};

export const handleBookImageError = (event) => {
  if (event.currentTarget.getAttribute('src') !== PLACEHOLDER) {
    event.currentTarget.src = PLACEHOLDER;
  }
};

export const BOOK_IMAGE_PLACEHOLDER = PLACEHOLDER;
